export const TRAVEL_LABELS = {
  airport: { tivat: 'Tivat', podgorica: 'Podgorica', other: 'Other' },
  transfer: { yes: 'Yes', own: 'No, own transportation', other: 'Other' },
  cold: { montenegrin: 'Traditional Montenegrin', salmon: 'Salmon tartare', vegan: 'Vegan (quinoa salad)' },
  main: { monkfish: 'Monkfish & risotto', beef: 'Beef medallions', vegan: 'Vegan (grilled tofu)' },
  beauty: { makeup: 'Makeup', hair: 'Hairstyling', full_look: 'Full look (makeup + hair)', none: 'Not needed' },
  allergy: { lactose: 'Lactose', gluten: 'Gluten', citrus: 'Citrus', nuts: 'Nuts', red_fruits: 'Red fruits & veg', other: 'Other' },
  drink: { red_wine: 'Red wine', white_wine: 'White wine', rose: 'Rosé', sparkling: 'Sparkling wine', beer: 'Beer', rakija: 'Local rakija', vodka: 'Vodka', gin: 'Gin', whisky: 'Whiskey', rum: 'Rum', tequila: 'Tequila' },
  kidsAppetizer: { pasta_cheese: 'Pasta with cheese', pasta_napolitan: 'Pasta Napolitan', mozzarella_sticks: 'Crispy mozzarella sticks' },
  kidsMain: { nuggets: 'Chicken nuggets with fries', chicken_mashed: 'Chicken fillet with mashed potatoes', burger: 'Burger with fries' }
};

export const formatTravelDate = (iso) => {
  if (!iso) return '—';
  const [y, m, d] = iso.split('-');
  return `${d}.${m}.${y}`;
};
